export default "__VITE_ASSET__4cf9eea4__"